import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridStyle } from '../../types';
import { DrawStyleModalComponent } from '../draw-style/draw-style-modal.component';

@Component({
	selector: 'bp-grid-controls',
	standalone: true,
	imports: [CommonModule, FormsModule],
	templateUrl: './grid-controls.component.html',
	styleUrls: ['./grid-controls.component.css']
})
export class GridControlsComponent {
	private modalService = inject(NgbModal);

	// Inputs
	@Input() gridEnabled = false;
	@Input() gridResolution = 5;
	@Input() gridRadius = 3;
	@Input() gridStyle: GridStyle = { color: '#3388ff', fillColor: '#3388ff', fillOpacity: 0.5, radius: 3 };

	// Kompakter Modus für ProjectLayers (nur Indikator + Modal mit allen Einstellungen)
	@Input() compact = false;

	// Outputs
	@Output() enabledChange = new EventEmitter<boolean>();
	@Output() resolutionChange = new EventEmitter<number>();
	@Output() radiusChange = new EventEmitter<number>();
	@Output() styleChange = new EventEmitter<GridStyle>();

	// Getter für Farben
	getGridFillColor(): string {
		const hex = this.gridStyle.fillColor;
		const opacity = this.gridStyle.fillOpacity;
		const r = parseInt(hex.slice(1, 3), 16);
		const g = parseInt(hex.slice(3, 5), 16);
		const b = parseInt(hex.slice(5, 7), 16);
		return `rgba(${r}, ${g}, ${b}, ${opacity})`;
	}

	getGridStrokeColor(): string {
		return this.gridStyle.color;
	}

	// Methoden
	toggleGrid(): void {
		this.enabledChange.emit(!this.gridEnabled);
	}

	onResolutionChange(value: string): void {
		this.resolutionChange.emit(parseFloat(value));
	}

	onRadiusChange(value: string): void {
		const radius = parseInt(value);
		this.radiusChange.emit(radius);
	}

	openStyleModal(): void {
		const modalRef = this.modalService.open(DrawStyleModalComponent, {
			centered: true,
			size: 'md'
		});
		modalRef.componentInstance.layerId = 'grid';
		modalRef.componentInstance.layerStyle = {
			strokeColor: this.gridStyle.color,
			strokeWidth: 1,
			fillColor: this.gridStyle.fillColor,
			fillOpacity: this.gridStyle.fillOpacity
		};

		modalRef.result.then((newStyle) => {
			if (newStyle) {
				const updatedStyle: GridStyle = {
					color: newStyle.strokeColor,
					fillColor: newStyle.fillColor,
					fillOpacity: newStyle.fillOpacity,
					radius: this.gridRadius
				};
				this.styleChange.emit(updatedStyle);
			}
		}).catch(() => {});
	}
}
